const pages = {
  company: [
    {
      title: '¿Para que sirve Hauscanner?',
      href: '/faq',
    },
    {
      title: '¿Tiene algún costo?',
      href: '/faq',
    },
    {
      title: '¿De que sirven las notificaciones?',
      href: '/faq',
    },
    {
      title: '¿Puedo acceder a datos del mercado?',
      href: '/faq',
    },
  ],
  account: [
    {
      title: 'Mi suscripción',
      href: '/account-notifications',
    },
    {
      title: 'Ajustes de cuenta',
      href: '/account-general',
    },
    {
      title: 'Notificaciones',
      href: '/account-general',
    },
    {
      title: 'Mis favoritos',
      href: '/account-notifications',
    },
    {
      title: 'Verificar mi correo',
      href: '/account-notifications',
    },
  ],
  secondary: [
    {
      title: 'Barranquilla',
      href: '/properties?filters=%7B%22address.city%22%3A%22Barranquilla%22%2C%22info.type%22%3A%5B%22apartamento%22%2C%22bodega%22%2C%22lote%22%2C%22local%22%2C%22casa%22%2C%22Casa%20campestre%22%2C%22Casa%20Lote%22%2C%22Edificio%22%2C%22Finca%22%2C%22Edificio%20de%20Apartamentos%22%2C%22Oficina%22%2C%22Local%20Comercial%22%2C%22Edificio%20de%20Oficinas%22%2C%22Caba%C3%B1a%22%2C%22Apartaestudio%22%2C%22Lote%20o%20Casalote%22%2C%22Consultorio%22%5D%7D',
    },
    {
      title: 'Bogotá',
      href: '/properties?filters=%7B%22address.city%22%3A%22Bogota%22%2C%22info.type%22%3A%5B%22apartamento%22%2C%22bodega%22%2C%22lote%22%2C%22local%22%2C%22casa%22%2C%22Casa%20campestre%22%2C%22Casa%20Lote%22%2C%22Edificio%22%2C%22Finca%22%2C%22Edificio%20de%20Apartamentos%22%2C%22Oficina%22%2C%22Local%20Comercial%22%2C%22Edificio%20de%20Oficinas%22%2C%22Caba%C3%B1a%22%2C%22Apartaestudio%22%2C%22Lote%20o%20Casalote%22%2C%22Consultorio%22%5D%7D',
    },
    {
      title: 'Medellín',
      href: '/properties?filters=%7B%22address.city%22%3A%22Medellin%22%2C%22info.type%22%3A%5B%22apartamento%22%2C%22bodega%22%2C%22lote%22%2C%22local%22%2C%22casa%22%2C%22Casa%20campestre%22%2C%22Casa%20Lote%22%2C%22Edificio%22%2C%22Finca%22%2C%22Edificio%20de%20Apartamentos%22%2C%22Oficina%22%2C%22Local%20Comercial%22%2C%22Edificio%20de%20Oficinas%22%2C%22Caba%C3%B1a%22%2C%22Apartaestudio%22%2C%22Lote%20o%20Casalote%22%2C%22Consultorio%22%5D%7D',
    },
    {
      title: 'Cali',
      href: '/properties?filters=%7B%22address.city%22%3A%22Cali%22%2C%22info.type%22%3A%5B%22apartamento%22%2C%22bodega%22%2C%22lote%22%2C%22local%22%2C%22casa%22%2C%22Casa%20campestre%22%2C%22Casa%20Lote%22%2C%22Edificio%22%2C%22Finca%22%2C%22Edificio%20de%20Apartamentos%22%2C%22Oficina%22%2C%22Local%20Comercial%22%2C%22Edificio%20de%20Oficinas%22%2C%22Caba%C3%B1a%22%2C%22Apartaestudio%22%2C%22Lote%20o%20Casalote%22%2C%22Consultorio%22%5D%7D',
    },
    {
      title: 'Cartagena',
      href: '/properties?filters=%7B%22address.city%22%3A%Cartagena%22%2C%22info.type%22%3A%5B%22apartamento%22%2C%22bodega%22%2C%22lote%22%2C%22local%22%2C%22casa%22%2C%22Casa%20campestre%22%2C%22Casa%20Lote%22%2C%22Edificio%22%2C%22Finca%22%2C%22Edificio%20de%20Apartamentos%22%2C%22Oficina%22%2C%22Local%20Comercial%22%2C%22Edificio%20de%20Oficinas%22%2C%22Caba%C3%B1a%22%2C%22Apartaestudio%22%2C%22Lote%20o%20Casalote%22%2C%22Consultorio%22%5D%7D',
    },
    {
      title: 'Santa Marta',
      href: '/properties?filters=%7B%22address.city%22%3A%22Santa-Marta%22%2C%22info.type%22%3A%5B%22apartamento%22%2C%22bodega%22%2C%22lote%22%2C%22local%22%2C%22casa%22%2C%22Casa%20campestre%22%2C%22Casa%20Lote%22%2C%22Edificio%22%2C%22Finca%22%2C%22Edificio%20de%20Apartamentos%22%2C%22Oficina%22%2C%22Local%20Comercial%22%2C%22Edificio%20de%20Oficinas%22%2C%22Caba%C3%B1a%22%2C%22Apartaestudio%22%2C%22Lote%20o%20Casalote%22%2C%22Consultorio%22%5D%7D',
    },
  ],
  subscription: [
    {
      title: 'Manejar suscripciones',
      href: '/account-general',
    },
    {
      title: 'Precios',
      href: '/pricing',
    },
  ],
};

export default pages;
